<template>
    <div class="cart-item card-wrap" :style="widthD ? { width: widthD } : {}" @mousemove="handleMouseMove" @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave" ref="card" @click="showDetail(item)" v-if="lang">
        <div class="card" :style="cardStyle">
            <div class="card-bg" :style="cardBgTransform">
                <div class="img-wrapper">
                    <img :src="item._logo" alt="">
                </div>
                <p class="item-des">{{ item.worksName }}</p>
                <p class="info-item">{{ lang === 'en' ? 'Name of creator' : '主创者' }}: {{ item.creatorName }}</p>
                <p class="info-item">{{ lang === 'en' ? 'Country' : '国家' }}: {{ item.countryRegion }}</p>
                <div class="cart-button">
                    <span>{{ lang === 'en' ? 'Read story' : '进入浏览' }}</span>
                </div>
                <div class="card-info">
                    <div class="content">{{ item.workIntroductin }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'youth-science-card',
    props: ['item', 'lang', 'widthD'],
    data() {
        return {
            width: 0,
            height: 0,
            mouseX: 0,
            mouseY: 0,
            mouseLeaveDelay: null,
        }
    },
    computed: {
        mousePX() {
            return this.mouseX / this.width;
        },
        mousePY() {
            return this.mouseY / this.height;
        },
        cardStyle() {
            const rX = this.mousePX * 30;
            const rY = this.mousePY * -30;
            return { transform: `rotateY(${rX}deg) rotateX(${rY}deg)` }
        },
        cardBgTransform() {
            const tX = this.mousePX * -40;
            const tY = this.mousePY * -40;
            return { transform: `translateX(${tX}px) translateY(${tY}px)` }
        }
    },
    mounted() {
        this.width = this.$refs.card.offsetWidth;
        this.height = this.$refs.card.offsetHeight;
    },
    methods: {
        showDetail(item) {
            this.$emit('showDetail', item);
        },
        handleMouseMove(e) {
            // this.mouseX = e.pageX - this.$refs.card.offsetLeft - this.width / 2;
            // this.mouseY = e.pageY - this.$refs.card.offsetTop - this.height / 2;
            this.mouseX = e.layerX - this.width / 2;
            this.mouseY = e.layerY - this.height / 2;
        },
        handleMouseEnter() {
            clearTimeout(this.mouseLeaveDelay);
        },
        handleMouseLeave() {
            this.mouseLeaveDelay = setTimeout(() => {
                this.mouseX = 0;
                this.mouseY = 0;
            }, 1000);
        }
    }
}
</script>
<style scoped>
.cart-item {
    vertical-align: top;
    width: 28rem;
    display: inline-block;
    margin-right: 2rem;
    margin-bottom: 2.5rem;
    /* background-color: #ffffff; */
}

.img-wrapper {
    width: 100%;
    height: 18.5rem;
    line-height: 18.5rem;
    text-align: center;
    font-size: 0px;
}

.img-wrapper img {
    width: 100%;
    height: 100%;
}

.item-des {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    height: 5rem;
    line-height: 1.5;
    padding: 0 2rem;
    margin-top: 2rem;
    font-size: 1.6rem;
    font-weight: 550;
    color: #343434;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.info-item {
    font-size: 1.4rem;
    padding-left: 2rem;
    padding-right: 2rem;
    margin: 0px;
    color: #484848;
}

.cart-button {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
}

.cart-button span {
    cursor: pointer;
    padding: 1rem 4rem;
    color: #ec6000;
    border-radius: 2rem;
    font-size: 1.8rem;
    border: 1px solid #ec6000;
}

.cart-button span:hover {
    background-color: #ec6000;
    color: #ffffff;
}


.m-list-wrapper .cart-item {
    width: 44vw;
    margin-left: 2vw;
    margin-right: 2vw;
    text-align: left;
}

.m-list-wrapper .item-des {
    line-height: 1.5;
    height: 40px;
    font-size: 14px;
    text-align: left;
}

.m-list-wrapper .info-item {
    font-size: 14px;
}

.m-list-wrapper .cart-button {
    margin-top: 10px;
    margin-bottom: 10px;
}

.m-list-wrapper .cart-button span {
    font-size: 14px;
    border-radius: 14px;
}
</style>

<style scoped>
.card-wrap {
    -webkit-transform: perspective(800px);
    transform: perspective(800px);
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    cursor: pointer;
}


.card {
    position: relative;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 240px;
    flex: 0 0 240px;
    /* width: 240px;
  height: 320px; */
    /* background-color: #333; */
    overflow: hidden;
    border-radius: 10px;
    /* box-shadow: rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset rgba(255, 255, 255, 0.5) 0 0 0 6px; */
    -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.card-bg {
    /* opacity: 0.5; */
    /* position: absolute;
  top: -20px;
  right: -20px;
  bottom: -20px;
  left: -20px; */

    /* width: 100%;
  height: 100%; */
    /* padding: 20px; */
    /* background-color: rgba(255, 255, 255, 0); */
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    pointer-events: none;
}

.card-info {
    opacity: 0;
    padding: 40px 40px 60px;
    position: absolute;
    top: -20px;
    right: -20px;
    bottom: -20px;
    left: -20px;
    color: #fff;

    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    -webkit-transition: 1s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: 1s 1.6s all cubic-bezier(0.215, 0.61, 0.355, 1);

}

.card-info .content {
    opacity: 1;
    text-indent: 2em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 12;
    -webkit-box-orient: vertical;
    transition: 1s 1.6s all cubic-bezier(0.215, 0.61, 0.355, 1);
}

.card-info:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background-image: -webkit-linear-gradient(top, transparent 0%, rgba(0, 0, 0, 0.6) 100%);
    background-image: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.6) 100%);
    background-blend-mode: overlay;
    opacity: 0;
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    -webkit-transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: 5s 1s all cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.card-wrap:hover .card-info {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.7);
    -webkit-transform: translateY(0);
    transform: translateY(0);
}

.card-wrap:hover .card-info .content {
    -webkit-transform: translateY(0);
    transform: translateY(0);
}

.card-wrap:hover .card-info {
    -webkit-transition: 1s cubic-bezier(0.23, 1, 0.32, 1);
    transition: 1s cubic-bezier(0.23, 1, 0.32, 1);
}

.card-wrap:hover .card-info:after {
    -webkit-transition: 5s cubic-bezier(0.23, 1, 0.32, 1);
    transition: 5s cubic-bezier(0.23, 1, 0.32, 1);
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
}

.card-wrap:hover .card-bg {
    -webkit-transition: 1s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
    transition: 1s cubic-bezier(0.23, 1, 0.32, 1), opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
    opacity: 0.8;
}

.card-wrap:hover .card {
    -webkit-transition: 1s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);
    transition: 1s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);
    box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px, white 0 0 0 1px, rgba(0, 0, 0, 0.66) 0 30px 60px 0, inset #333 0 0 0 5px, inset white 0 0 0 6px;
}
</style>
